import enLocale from 'date-fns/locale/en-US';
import nbLocale from 'date-fns/locale/nb';
import svLocale from 'date-fns/locale/sv';

export const dateFnsLocales = { en: enLocale, no: nbLocale, se: svLocale };
